import { render, staticRenderFns } from "./ExamAttributeDetails.vue?vue&type=template&id=06a0f7d6&scoped=true&"
import script from "./ExamAttributeDetails.vue?vue&type=script&lang=ts&"
export * from "./ExamAttributeDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ExamAttributeDetails.vue?vue&type=style&index=0&id=06a0f7d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a0f7d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
